import { render, staticRenderFns } from "./SubEmpresaModalRevisarTerritorio.vue?vue&type=template&id=184cb482&lang=pug"
import script from "./SubEmpresaModalRevisarTerritorio.vue?vue&type=script&lang=js"
export * from "./SubEmpresaModalRevisarTerritorio.vue?vue&type=script&lang=js"
import style0 from "./SubEmpresaModalRevisarTerritorio.vue?vue&type=style&index=0&id=184cb482&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports